import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { EuiSpacer } from '@elastic/eui';
import SuccessBox from 'components/Web_User_Interface/1440p_Series/System/Date_Time/SuccessBox';
import PermissionBox from 'components/Web_User_Interface/1440p_Series/_permissions/SystemPerm';
import DateTable from 'components/Web_User_Interface/1440p_Series/System/Date_Time/dateTable';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
export const _frontmatter = {
  "title": "System Menü // Datum & Uhrzeit",
  "path": "/Web_User_Interface/1440p_Serie/System/Datum_Uhrzeit/",
  "dateChanged": "2021-12-12",
  "author": "Mike Polinowski",
  "excerpt": "Sie können die interne Zeit Ihrer Kamera entweder manuell mit der Zeit des zugreifenden PCs oder automatisch mit Internet Zeitservern (NTP) synchronisieren. Solange die Kamera Kontakt zum Internet hat, empfehlen wir den Abgleich mit einem NTP Server Ihrer Wahl, um eine möglichst hohe Genauigkeit zu erreichen. Beachten Sie bitte, dass Sie die Sommerzeit manuell aktivieren müssen, wenn Sie sich in einer Zeitzone aufhalten, in der die Zeit im Sommer eine Stunde vorgestellt wird.",
  "image": "./WebUI_1440p_SearchThumb_System_Date_Time.png",
  "social": "/images/Search/WebUI_1440p_SearchThumb_System_Date_Time.webp",
  "toc": "/images/Search/TOC_Icons/Wiki_Tiles_WebUI_white.webp",
  "chapter": "1440p Web User Interface"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <SEOHelmet title='System Menü // Datum & Uhrzeit' dateChanged='2021-12-12' author='Mike Polinowski' tag='INSTAR IP Camera' description='Sie können die interne Zeit Ihrer Kamera entweder manuell mit der Zeit des zugreifenden PCs oder automatisch mit Internet Zeitservern (NTP) synchronisieren. Solange die Kamera Kontakt zum Internet hat, empfehlen wir den Abgleich mit einem NTP Server Ihrer Wahl, um eine möglichst hohe Genauigkeit zu erreichen. Beachten Sie bitte, dass Sie die Sommerzeit manuell aktivieren müssen, wenn Sie sich in einer Zeitzone aufhalten, in der die Zeit im Sommer eine Stunde vorgestellt wird.' image='/images/Search/WebUI_1440p_SearchThumb_System_Date_Time.png' twitter='/images/Search/WebUI_1440p_SearchThumb_System_Date_Time.webp' location={props.location.pathname} mdxType="SEOHelmet" />
    <BreadCrumbs locationBC={props.location} locationDE={props.location.pathname} locationEN='/en/Web_User_Interface/1440p_Series/System/Date_Time/' locationFR='/fr/Web_User_Interface/1440p_Series/System/Date_Time/' crumbLabel="Date & Time" mdxType="BreadCrumbs" />
    <h1 {...{
      "id": "ultrahd-serien-2k-1440p--4k-2160p",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#ultrahd-serien-2k-1440p--4k-2160p",
        "aria-label": "ultrahd serien 2k 1440p  4k 2160p permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`UltraHD Serien (2K+ 1440p & 4K 2160p)`}</h1>
    <h2 {...{
      "id": "system-menü",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#system-men%C3%BC",
        "aria-label": "system menü permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`System Menü`}</h2>
    <EuiSpacer mdxType="EuiSpacer" />
    <SuccessBox mdxType="SuccessBox" />
    <EuiSpacer mdxType="EuiSpacer" />
    <PermissionBox mdxType="PermissionBox" />
    <EuiSpacer mdxType="EuiSpacer" />
    <h3 {...{
      "id": "synchronisieren-sie-die-kamerazeit",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#synchronisieren-sie-die-kamerazeit",
        "aria-label": "synchronisieren sie die kamerazeit permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Synchronisieren Sie die Kamerazeit`}</h3>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/5c2df7a63611ceaaf3227eecd04c7065/b97f6/1440p_Settings_System_Date_Time.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "58.26086956521739%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAA7rAAAO6wFxzYGVAAACN0lEQVQoz22SS08TURiG+RcSMRTwAtNpI9ACKZZ2etOZdjqXc+ZS2kJBSYwbFuxcEdgYI2riPzDqip2YGH/dY84p5aIsnryTM5kn7/edmcrlcmQNg/zTVRoH72m++ULl4CPl/TPKL++m8uqM5uvPhIefKJe3mJ6+x8zMDHNzc0wpoWEskV8p0js+Z/juN8npBfElyekvTaw4uSA6UWc/2f/wh53jH5RKZR4/eoKZzbG4uMRUNptFYZpZfNchlQGJ8EmERyw8pN8h9NpEQZdU+vTikF4UkMYhntum/KxGtdLAqrYoFNaZMk3zUmgihGQwHJKkKTKKrhBSEiepfjca7TEajRjt7SFlRN1qUq2MpYXVtdvCIAiI45gwDBFC6Ox2u3Q9T6frKlw6ik6HMPRx23VqVv220DCMK2GSJFompcT3fWzbxnEcnTefW60WUrikUY3qlqWFRTXy9Q7HwjRNtVRlpEaW8j+ECEl6A3rbKZ5TwapYtOo11oo3GirpTaEiklKPPUE11+1FSJju0h/sIh2LWrWihYVC8e6GqpnapcqJKAhCvTu1Q7ftYAcpu/0djvoujVqNZr1Fsbgx/g8nF6M+7vf7ut2/wm6njVXdwrIsNjY3WS+VcB0b2SxRWFlmeXmVrGFe37ISq0sY70hcpRbKCJEM8eMBIpBsuy4Dz6dj29x/MMvs7JhMJnM9cj6f18KJRKN2FviE2/vEb78SHp9zuHPE90aLb7bP6PkLMg8XWJifZ/6SvxCWwGo80GmPAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/5c2df7a63611ceaaf3227eecd04c7065/e4706/1440p_Settings_System_Date_Time.avif 230w", "/de/static/5c2df7a63611ceaaf3227eecd04c7065/d1af7/1440p_Settings_System_Date_Time.avif 460w", "/de/static/5c2df7a63611ceaaf3227eecd04c7065/7f308/1440p_Settings_System_Date_Time.avif 920w", "/de/static/5c2df7a63611ceaaf3227eecd04c7065/44a65/1440p_Settings_System_Date_Time.avif 958w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/5c2df7a63611ceaaf3227eecd04c7065/a0b58/1440p_Settings_System_Date_Time.webp 230w", "/de/static/5c2df7a63611ceaaf3227eecd04c7065/bc10c/1440p_Settings_System_Date_Time.webp 460w", "/de/static/5c2df7a63611ceaaf3227eecd04c7065/966d8/1440p_Settings_System_Date_Time.webp 920w", "/de/static/5c2df7a63611ceaaf3227eecd04c7065/cb8de/1440p_Settings_System_Date_Time.webp 958w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/5c2df7a63611ceaaf3227eecd04c7065/81c8e/1440p_Settings_System_Date_Time.png 230w", "/de/static/5c2df7a63611ceaaf3227eecd04c7065/08a84/1440p_Settings_System_Date_Time.png 460w", "/de/static/5c2df7a63611ceaaf3227eecd04c7065/c0255/1440p_Settings_System_Date_Time.png 920w", "/de/static/5c2df7a63611ceaaf3227eecd04c7065/b97f6/1440p_Settings_System_Date_Time.png 958w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/5c2df7a63611ceaaf3227eecd04c7065/c0255/1440p_Settings_System_Date_Time.png",
              "alt": "Web User Interface - 1440p Series - System Date & Time",
              "title": "Web User Interface - 1440p Series - System Date & Time",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <EuiSpacer mdxType="EuiSpacer" />
    <DateTable mdxType="DateTable" />
    <EuiSpacer mdxType="EuiSpacer" />
    <p>{`Sie können die interne Uhr der Kamera so einstellen, dass sie entweder mit Ihrer PC-Uhr oder mit einem der verschiedenen NTP-Server synchronisiert wird. Solange Ihre Kamera Zugang zum Internet hat, ist es empfehlenswert, eine NTP-Server-Synchronisation zu verwenden, um eine höhere Genauigkeit für Alarmauslösungsereignisse zu erreichen.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      